import BaseComponent from "./BaseComponent";

export default class FormPrefillController extends BaseComponent {
    constructor() {
        super();

        this._items = null;

        this._initPrefillController();
    }

    _initPrefillController() {
        this._items = Array.from(document.querySelectorAll('li.blb-news-list-item.prefill-form'));

        this._items.forEach((item) => {
            let hrefItem = item.querySelector('div.blb-news-item-description a[href*="/die-blb/formulare/"]');

            if (hrefItem !== null) {
                let currentUrl = hrefItem.href.split('#')[0];
                let eventDate = item.querySelector('div.blb-news-item-date h3').textContent.toString();
                let eventTitle = item.querySelector('div.blb-news-item-title h3').textContent.toString();
                let newUrl = currentUrl.concat('?tx_powermail_pi1[field][themaderveranstaltung]='+(eventTitle)+'&tx_powermail_pi1[field][veranstaltungsdatum]='+(eventDate)+'');

                hrefItem.href = newUrl;
            }
        });
    }
}
